module.exports = __webpack_public_path__ + "static/img/panovideo.cef653e0.jpg";